import cn from 'classnames';

import { IConDefaultType } from '..';

export enum FavoriteIconVariant {
  ON = 'on',
  OFF = 'off',
  BUBBLE_CHAT_FILL = 'bubble_chat_fill',
  SIDE_MENU = 'side_menu',
}

export interface IFavoriteIconProps extends IConDefaultType {
  variant?: FavoriteIconVariant;
}

function FavoriteIcon({
  color = '#ADB0B8',
  className,
  size = 24,
  rotate,
  flip,
  variant = FavoriteIconVariant.OFF,
  style,
}: IFavoriteIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    >
      {variant === FavoriteIconVariant.OFF && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.6794 9.23012C19.6789 9.21237 19.6787 9.1946 19.6787 9.17684C19.6787 7.30848 18.1807 5.82118 16.3626 5.82118C15.4852 5.82118 14.6435 6.17099 14.023 6.79759L14.0213 6.79927L13.3638 7.46157C13.0033 7.82467 12.5129 8.02887 12.0012 8.02887C11.4896 8.02887 10.9991 7.82467 10.6386 7.46157L9.98114 6.79927C9.971 6.78905 9.96099 6.77875 9.95112 6.76835C9.32797 6.1591 8.49878 5.82118 7.64223 5.82118C5.81967 5.82118 4.32137 7.31055 4.32137 9.17804C4.32137 10.0485 4.65792 10.8846 5.25366 11.5083C5.26922 11.523 5.28455 11.5379 5.29965 11.5531L12.0012 18.3029L18.7028 11.5531C18.7179 11.5379 18.7332 11.523 18.7487 11.5084C19.3313 10.8984 19.6653 10.0873 19.6796 9.2354L19.6794 9.23012ZM21.5999 9.22004C21.5942 9.95122 21.4379 10.6653 21.1485 11.3207C20.9051 11.872 20.5675 12.3818 20.1461 12.8251C20.1199 12.8527 20.0934 12.88 20.0666 12.907C20.0666 12.907 20.0667 12.9069 20.0666 12.907L20.0653 12.9059L19.7589 13.2145L12.5579 20.4673C12.2508 20.7756 11.7517 20.7756 11.4445 20.4673L3.93715 12.9059L3.93595 12.9071C3.90878 12.8797 3.88193 12.8521 3.85541 12.8242C3.85541 12.8242 3.85542 12.8242 3.85541 12.8242C3.43468 12.3813 3.09728 11.8717 2.85382 11.3207C2.55848 10.6523 2.40137 9.92302 2.40137 9.17804C2.40137 6.26245 4.74704 3.90118 7.64223 3.90118C8.37985 3.90118 9.10187 4.05864 9.76424 4.35478C10.2524 4.57303 10.7082 4.86661 11.1139 5.22802C11.1924 5.29794 11.2691 5.37041 11.3437 5.44536C11.3435 5.44516 11.3439 5.44556 11.3437 5.44536C11.3439 5.44556 11.3447 5.44637 11.3449 5.44657L12.0012 6.10887L12.6587 5.44657C12.7328 5.37178 12.8088 5.29949 12.8868 5.22973C12.9894 5.13786 13.0953 5.05039 13.2042 4.96743C14.108 4.27862 15.2161 3.90118 16.3626 3.90118C19.2542 3.90118 21.5987 6.26125 21.5987 9.17684L21.5999 9.22004Z"
            fill={color}
          />
        </svg>
      )}
      {variant === FavoriteIconVariant.ON && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.5987 9.17684C21.5987 6.26125 19.2542 3.90118 16.3626 3.90118C14.9732 3.90118 13.6402 4.45551 12.6587 5.44657L12.0012 6.10887L11.3437 5.44657H11.3449C10.361 4.45791 9.02923 3.90118 7.64223 3.90118C4.74704 3.90118 2.40137 6.26245 2.40137 9.17804C2.40137 10.5758 2.95449 11.9185 3.93595 12.9071L3.93715 12.9059L11.4445 20.4673C11.7517 20.7756 12.2508 20.7756 12.5579 20.4673L20.0653 12.9059L20.0665 12.9071C21.0383 11.9281 21.5891 10.6046 21.5999 9.22004L21.5987 9.17684Z"
            fill="#00C3DD"
          />
        </svg>
      )}

      {variant === FavoriteIconVariant.BUBBLE_CHAT_FILL && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.001 4.52853C14.35 2.42 17.98 2.49 20.2426 4.75736C22.5053 7.02472 22.583 10.637 20.4786 12.993L11.9999 21.485L3.52138 12.993C1.41705 10.637 1.49571 7.01901 3.75736 4.75736C6.02157 2.49315 9.64519 2.41687 12.001 4.52853Z"
            fill={color}
          />
        </svg>
      )}
      {variant === FavoriteIconVariant.SIDE_MENU && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <path
            d="M12.001 4.52853C14.35 2.42 17.98 2.49 20.2426 4.75736C22.5053 7.02472 22.583 10.637 20.4786 12.993L11.9999 21.485L3.52138 12.993C1.41705 10.637 1.49571 7.01901 3.75736 4.75736C6.02157 2.49315 9.64519 2.41687 12.001 4.52853ZM18.827 6.1701C17.3279 4.66794 14.9076 4.60701 13.337 6.01687L12.0019 7.21524L10.6661 6.01781C9.09098 4.60597 6.67506 4.66808 5.17157 6.17157C3.68183 7.66131 3.60704 10.0473 4.97993 11.6232L11.9999 18.6543L19.0201 11.6232C20.3935 10.0467 20.319 7.66525 18.827 6.1701Z"
            fill={color || 'black'}
          />
        </svg>
      )}
    </i>
  );
}

export default FavoriteIcon;
